require('./sendExtractsViaMailView.scss');
// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');
const { formatText } = require('core/i18n').i18n;
// @helpers
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname')
// @components
const OKHeaderCC = require('components/commons/OKHeaderCC/OKHeaderCC');
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');

const SendExtractsViaMailStep1 = require('./sendExtractsViaMailStep1/sendExtractsViaMailStep1');
const SendExtractsViaMailStep2 = require('./sendExtractsViaMailStep2/sendExtractsViaMailStep2');

const VerifyOtpStep = require('components/commons/verifyOtpStep/verifyOtpStep');
const { LoadingSection } = require('commonsComponents/loadingSection');
const CustomMessageBox = require('components/contactCenter/customMessageBox/customMessageBox');
const PreleaveCancelModal = require('components/contactCenter/preleaveCancelModal/preleaveCancelModal');
// @constants
const { WIZARD_VERTICAL_VIEW_MODE } = require('constants/index');
const { SEND_EXTRACTS_VIA_MAIL } = require('constants/contactCenter/operationTypes');
const { EMAILCONSTANTS } = require('constants/contactCenter/emailConstants');

const translationNamespace = 'sendExtractsViaMail';

class SendExtractsViaMailView extends React.Component {
    constructor(props) {
        super(props);
        this.handleShowCancelModal = this.handleShowCancelModal.bind(this);
        this.handleHideCancelModal = this.handleHideCancelModal.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.onHandleGoBack = this.onHandleGoBack.bind(this);
    }

    componentWillUnmount() {
        this.props.reset();
    }

    getTranslationNamespace() {
        const { match: { params: { extractType } } } = this.props;
        return `${translationNamespace}${extractType}`
    }

    buildPreleaveCancelModal() {
        const { immSendExtractsViaMail } = this.props;
        const showCancelModal = immSendExtractsViaMail.get('showCancelModal');

        return (
            <PreleaveCancelModal
                isOpen={showCancelModal}
                onCancel={this.handleCancel}
                onCloseModal={this.handleHideCancelModal}
                onStayHere={this.handleHideCancelModal}
            />
        );
    }

    handleShowCancelModal() {
        const { showCancelModal } = this.props;
        showCancelModal(true);
    }

    handleHideCancelModal() {
        const { showCancelModal } = this.props;
        showCancelModal(false);
    }

    handleCancel() {
        const cancelPath = '/myprofile/documentation/';
        this.props.history.push(cancelPath);
    }

    onHandleGoBack() {
        const cancelPath = '/myprofile/documentation/';
        this.props.history.push(cancelPath);
    }

    buildHeader() {
        const title = formatText(`${this.getTranslationNamespace()}-title`);
        const breadcrumpMap = [
            {
                text: formatText('breadcrumb-documentation'),
                url: '/myprofile/documentation'
            },
            {
                text: title
            }
        ];

        return (
            <OKHeaderCC
                breadcrumbConfig={breadcrumpMap}
                showBreadBrumb={true}
            />
        );
    }

    handleFinish() {
        const { match: { params: { extractType } }, confirmSendExtractsViaMail, immDocuments } = this.props;
        const productName = EMAILCONSTANTS[extractType].productName;
        const templateCode = EMAILCONSTANTS[extractType].templateCode;
        const selectedDocument = immDocuments.get('selectedDocument');

        confirmSendExtractsViaMail({
            productName,
            templateCode,
            gestorDocumental: selectedDocument.get('gestorDocumental'),
            codigoSubaplicacion: selectedDocument.get('codSubaplicacion'),
            codComunicacion: selectedDocument.get('codComunicacion')
        });
    }

    buildSuccessfulFeedback() {
        return (
            <CustomMessageBox
                icon="icon-success"
                title={formatText(`${this.getTranslationNamespace()}-successfulFeedbackTitle`)}
                subtitle={formatText('sendExtractsViaMail-successfulFeedbackSubtitle')}
                textLink={formatText('sendExtractsViaMail-feedbackBackButton')}
                goBackHandler={this.onHandleGoBack}
            />
        );
    }

    buildErrorFeedback() {
        return (
            <CustomMessageBox
                icon="icon-warning"
                title={formatText(`${this.getTranslationNamespace()}-failureFeedbackTitle`)}
                textLink={formatText('sendExtractsViaMail-feedbackBackButton')}
                goBackHandler={this.onHandleGoBack}
            />
        );
    }

    buildWizard() {
        const {
            setVisibleStep,
            validateStep,
            immDocuments,
            immSendExtractsViaMail,
            immProfile,
            immPrecontractualMail,
            match: { params },
            requestProfile
        } = this.props;

        const currentStep = immSendExtractsViaMail.get('currentStep');
        const immSteps = immSendExtractsViaMail.get('steps');
        const actions = {
            finish: this.handleFinish,
            setVisibleStep,
            validateStep,
            setWillCancel: () => { },
            cancel: this.handleShowCancelModal
        }

        return (
            <Wizard
                viewMode={WIZARD_VERTICAL_VIEW_MODE}
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={currentStep}
            >

                <WizardStep
                    cancelButton={true}
                >
                    <SendExtractsViaMailStep1
                        immProfile={immProfile}
                        immPrecontractualMail={immPrecontractualMail}
                        requestProfile={requestProfile}
                    />
                </WizardStep>

                <WizardStep
                    position="middle"
                    cancelButton={true}
                    omitPreviousButton={false}
                >
                    <SendExtractsViaMailStep2
                        params={params}
                        immDocument={immDocuments.get('selectedDocument')}
                        immProfile={immProfile}
                    />
                </WizardStep>

                <WizardStep
                    position="last"
                    omitPreviousButton={false}
                    cancelButton={true}
                    addLoadingBehaviour={true}
                    isLoading={false}
                    immFinalButton={'sendExtractsViaMail-confirm'}
                >
                    <VerifyOtpStep
                        operationType={SEND_EXTRACTS_VIA_MAIL}
                        operationParams={{}}
                    />
                </WizardStep>
            </Wizard>
        );
    }


    buildContent() {
        const { history, immSendExtractsViaMail, immDocuments } = this.props;
        let pageContent;
        const sendExtractsViaMailClassName = contactCenterClassName('send-extracts-via-mail__content', 'col-xs-12')
        if (immSendExtractsViaMail.get('isFetching')) {
            pageContent = <LoadingSection />
        } else if (!immDocuments.getIn(['selectedDocument', 'fechaAlta'])) {
            history.push('/myprofile/documentation/');
        } else if (immSendExtractsViaMail.get('hasBeenFetched')) {
            pageContent = this.buildSuccessfulFeedback();
        } else if (immSendExtractsViaMail.get('error')) {
            pageContent = this.buildErrorFeedback();
        } else {
            const wizard = this.buildWizard();
            const preleaveCancelModal = this.buildPreleaveCancelModal();
            const content = (
                <div className={sendExtractsViaMailClassName}>
                    {wizard}
                    {preleaveCancelModal}
                </div>
            );
            pageContent = (
                <div>
                    {content}
                </div>
            );
        }

        return pageContent;
    }

    render() {
        const header = this.buildHeader();
        const content = this.buildContent();

        return (
            <div className="send-extracts-via-mail">
                {header}
                <div className="send-extracts-via-mail__body">
                    {content}
                </div>
            </div>

        );
    }
}

SendExtractsViaMailView.propTypes = {
    history: PropTypes.object.isRequired,
    immSendExtractsViaMail: PropTypes.object.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    showCancelModal: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    confirmSendExtractsViaMail: PropTypes.func.isRequired,
    immDocuments: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immPrecontractualMail: PropTypes.object.isRequired,
    requestProfile: PropTypes.func.isRequired,
};

module.exports = withRouter(SendExtractsViaMailView);
